import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

export default function AddVarientForm({
  formik,
  setShowVarientForm,
  setValidateVarient,
  showVarientForm,
  editingVarient,
  setEditingVarient,
}) {
  const { varientOptions, optionValues } = useSelector(
    (state) => state.ProductReducer
  );
  const { enableCurrency } = useSelector((state) => state.CurrencyReducer);

  const optionValueFilter = (id) => {
    return optionValues.filter((option) => option.option_id === id);
  };

  const getVarientOptions = varientOptions.reduce((acc, option) => {
    acc[option.label] = "";
    return acc;
  }, {});

  const getEditVarientOptions = editingVarient
    ? varientOptions.reduce((acc, option) => {
        acc[option.label] = editingVarient[option.label];
        return acc;
      }, {})
    : null;

  const handleCancel = () => {
    setShowVarientForm(false);
    setValidateVarient(false);
    setEditingVarient(null);
    formik.setValues({
      ...formik.values,
      varient: {
        ...getVarientOptions,
        quantity: "",
        price: formik?.values?.samePrice ? formik?.values?.price : 0,
        purchasePrice: formik?.values?.samePurchasePrice
          ? formik?.values?.purchasePrice
          : 0,
      }, // Reset the varient form
    });
  };

  const updateVarientInArray = (updatedVarient) => {
    const index = formik.values.varients.findIndex(
      (varient) => varient.id === editingVarient.id
    );

    if (index !== -1) {
      // Update the values of the object at the found index
      formik.values.varients[index] = {
        ...formik.values.varients[index],
        ...updatedVarient,
      };
    }

    formik.setValues({
      ...formik.values,
      varient: {
        ...getVarientOptions,
        quantity: "",
        price: formik?.values?.samePrice ? formik?.values?.price : 0,
        purchasePrice: formik?.values?.samePurchasePrice
          ? formik?.values?.purchasePrice
          : 0,
      }, // Reset the varient form
    });

    setEditingVarient(null); // Reset the editingVarient state after updating
    setShowVarientForm(false); // Close the varient form after updating

    toast.success("Varient Updated Successfully!");
  };

  const updateVarient = () => {
    if (editingVarient) {
      formik.validateForm().then((errors) => {
        if (Object.keys(errors).length === 0) {
          if (formik.isValid) {
            updateVarientInArray(formik.values.varient);
          }
        } else {
          console.log("Validation errors:", errors);
        }
      });
    }
  };

  const handleAddVarient = () => {
    formik.validateForm().then((errors) => {
      if (Object.keys(errors).length === 0) {
        if (formik.isValid) {
          const varientsArray = Array.isArray(formik.values.varients)
            ? formik.values.varients
            : [];

          const newVarient = formik.values.varient
            ? {
                ...formik.values.varient,
                id: formik.values.varients.length + 1,
              }
            : {};

          formik.setValues({
            ...formik.values,
            varients: [...varientsArray, newVarient],
            varient: {
              ...getVarientOptions,
              quantity: "",
              price: formik?.values?.samePrice ? formik?.values?.price : 0,
              purchasePrice: formik?.values?.samePurchasePrice
                ? formik?.values?.purchasePrice
                : 0,
            }, // Reset the varient form
          });

          setShowVarientForm(false);
          setValidateVarient(false);
          toast.success("Varient Added Successfully!");
        }
      } else {
        console.log("Validation errors:", errors);
      }
    });
  };

  useEffect(() => {
    // Set the formik values based on the editingVarient when it changes
    if (editingVarient) {
      formik.setValues((prevValues) => ({
        ...prevValues,
        varient: {
          ...prevValues.varient,
          ...getEditVarientOptions,

          quantity: editingVarient?.quantity,
          price: editingVarient?.price,
          purchasePrice: editingVarient?.purchasePrice,
        },
      }));
    }
  }, [editingVarient]);
  return (
    <>
      {/* <div className="mt-3 flex justify-end">
        <Button
          label="Add Varient"
          icon="pi pi-plus"
          className="p-primary-btn"
          onClick={() => {
            setShowVarientForm(true);
            setValidateVarient(true);
          }}
        />
      </div> */}

      {showVarientForm && (
        <div className="card shadow-md rounded-lg p-4 mt-4">
          <Divider>
            <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
              {editingVarient ? "Edit" : "Add"} Varient
            </span>
          </Divider>

          <div className="px-4 gap-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {varientOptions.map((varient) => {
              return (
                <div className="" key={varient.id}>
                  <div className="flex flex-col gap-2">
                    <label
                      htmlFor={"varient." + varient.label}
                      className="capitalize"
                    >
                      {varient.label}
                    </label>
                    <Dropdown
                      id={"varient." + varient.label}
                      name={"varient." + varient.label}
                      className="!w-full text-lg p-primary-input"
                      value={formik.values?.varient[`${varient?.label}`]}
                      onChange={(e) => {
                        formik.setValues({
                          ...formik.values,
                          varient: {
                            ...formik.values.varient,
                            [varient.label]: e.value,
                          },
                        });
                      }}
                      options={optionValueFilter(varient.id)}
                      optionLabel="value"
                      optionValue={(e) => {
                        return e;
                      }}
                      filter
                      pt={{
                        root: { className: "w-full" },
                        input: { className: "w-full p-primary-input" },
                        filterIcon: { className: "ml-1" },
                        filterInput: { className: "pl-6" },
                      }}
                    />
                  </div>
                  {formik.touched?.varient?.[varient.label] &&
                    formik.errors?.varient?.[varient.label] && (
                      <div className="p-error">
                        {formik.errors?.varient?.[varient.label]}
                      </div>
                    )}
                </div>
              );
            })}

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="varient.quantity" className="">
                  Quantity
                </label>
                <span className=" w-full">
                  <InputNumber
                    id="varient.quantity"
                    name="varient.quantity"
                    className="w-full text-lg p-primary-input"
                    value={formik.values?.varient?.quantity}
                    onValueChange={formik.handleChange}
                  />
                </span>
              </div>
              {formik.touched?.varient?.quantity &&
                formik.errors?.varient?.quantity && (
                  <div className="p-error">
                    {formik.errors?.varient?.quantity}
                  </div>
                )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="varient.purchasePrice" className="">
                  Purchase Price
                </label>
                <span className=" w-full">
                  <InputNumber
                    id="varient.purchasePrice"
                    name="varient.purchasePrice"
                    className="w-full text-lg p-primary-input"
                    value={
                      formik?.values?.samePurchasePrice
                        ? formik?.values?.purchasePrice
                        : formik?.values?.varient?.purchasePrice
                    }
                    onValueChange={formik.handleChange}
                    prefix={`${enableCurrency?.unit || ""} `}
                    disabled={formik.values.samePurchasePrice}
                  />
                </span>
              </div>
              {formik.touched?.varient?.purchasePrice &&
                formik.errors?.varient?.purchasePrice && (
                  <div className="p-error">
                    {formik.errors?.varient?.purchasePrice}
                  </div>
                )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="varient.price" className="">
                  Sale Price
                </label>
                <span className=" w-full">
                  <InputNumber
                    id="varient.price"
                    name="varient.price"
                    className="w-full text-lg p-primary-input"
                    value={
                      formik?.values?.samePrice
                        ? formik?.values?.price
                        : formik?.values?.varient?.price
                    }
                    onValueChange={formik.handleChange}
                    prefix={`${enableCurrency?.unit || ""} `}
                    disabled={formik.values.samePrice}
                  />
                </span>
              </div>
              {formik.touched?.varient?.price &&
                formik.errors?.varient?.price && (
                  <div className="p-error">{formik.errors?.varient?.price}</div>
                )}
            </div>
          </div>

          <div className="mt-8">
            <div className="flex justify-end gap-4">
              <Button
                label="Cancel"
                icon="pi pi-times"
                className="p-red-btn"
                type="button"
                onClick={handleCancel}
              />
              <Button
                label={editingVarient ? "Edit" : "Add"}
                icon="pi pi-check"
                className="p-secondary-btn"
                type="button"
                onClick={editingVarient ? updateVarient : handleAddVarient}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
